export enum VideoItemPanels {
  NONE = 'none',
  SHADOW = 'shadow',
  GLOW = 'glow',
  BORDER = 'border',
  TINT = 'tint',
  MULTIPLY = 'multiply',
  AI_SUBTITLES = 'ai-subtitles',
  ANIMATION = 'animation',
}
